import { Component, OnInit, Input, NgZone } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RestApiService } from "../../shared/rest-api.service";
import { Title } from "@angular/platform-browser";

declare let $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

	public packages: any;
	public ppackages: any;
	interval : any;

	constructor(
		public restApi: RestApiService, 
		public router: Router,
		public route: ActivatedRoute,
		public ngZone: NgZone,
		private titleService:Title) {
		
		this.titleService.setTitle("Home");
	}

	ngOnInit(): void {
		//this.getPackages();
		// $.getScript('assets/scripts/jquery-3.3.1.js', function(){});
		// $.getScript('assets/scripts/bootstrap.min.js', function(){});
		// $.getScript('assets/scripts/popper.js', function(){});
		// $.getScript('assets/scripts/owl.carousel.min.js', function(){});
		// let jsScript = document.createElement("script");
		// jsScript.type = "text/javascript";
		// jsScript.async = true;
		// jsScript.innerHTML  = "$(document).ready(function () { $('#testimonial-slider').owlCarousel({items: 1,itemsDesktop: [1000, 1],itemsDesktopSmall: [979, 1],itemsTablet: [768, 1],pagination: false,navigation: true,navigationText: ['', ''],autoPlay: true});});";
		// document.body.appendChild(jsScript); 
	}

	getPackages(): void {
		this.restApi.getPackages()
		  .subscribe(
			packages => {
				this.packages = packages;
				console.log(packages);
			},
			error => {
			  console.log(error);
			});
	}

/* 	getPPackages(): void {
		this.restApi.getPPackages()
		  .subscribe(
			ppackages => {
				this.ppackages = ppackages;
				console.log(ppackages);
			},
			error => {
			  console.log(error);
			});
	} */
	
	ngAfterViewInit(): void {
		setTimeout(function () {
			$.getScript('assets/scripts/jquery-3.3.1.js', function(){});
			let jsScript = document.createElement("script");
			jsScript.type = "text/javascript";
			jsScript.async = true;
			jsScript.innerHTML  = "$(document).ready(function () { $('.grecaptcha-badge').hide(); });";
			document.body.appendChild(jsScript); 
		},400);
	}

}
